module.exports = "mutation ($data: DraftInput!) {\n  DraftCreate(data: $data) {\n    id\n  }\n}\n"